export const environment = {
  DEVELOPMENT: "DEVELOPMENT",
  QA: "QA",
  STAGING: "STAGING",
  PRODUCTION: "PRODUCTION",
};
